import {connect} from "react-redux";
import MonthlyRegularization from "./MonthlyRegularization";
import {bindActionCreators} from "redux";
import { getDaysData, getMonthsNameFilter } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    getAllTheDaysData: state.DarwinAttendanceSync.getAllTheDaysData,
    getMonthsFilter: state.DarwinAttendanceSync.getMonthsFilter
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDaysData,
            getMonthsNameFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyRegularization);
